import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Entity, ENTITY_TYPE } from 'src/features/entity/types';
import { PATH } from 'src/features/navigation/utils/constants';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface CellEntityProps<TData, TValue> extends CellContext<TData, TValue> {
    type: ENTITY_TYPE;
}

export default function CellEntityActions({ row, type }: CellEntityProps<Entity, unknown>) {
    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/${PATH.ENTITIES}/${type}/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
